export default __webpack_public_path__ + "assets/mail-component.cdf0ef34.svg";